import React, { useEffect, useState } from "react";
import { PrimaryLarge } from "@streeteasy/design-system/typography";

import { appStoreIcon, googlePlayIcon } from "../../assets";
import * as S from "./styled";

const MobileApps = () => {
  const [platform, setPlatform] = useState("desktop");

  useEffect(() => {
    const { userAgent } = navigator;

    if (
      userAgent.match(/iPad/i) ||
      userAgent.match(/iPhone/i) ||
      userAgent.match(/iPod/i)
    ) {
      setPlatform("iOS");
    } else if (userAgent.match(/Android/i)) {
      setPlatform("android");
    }
  });

  return (
    <S.MobileAppsContainer>
      <PrimaryLarge as="h2">
        NYC moves quickly. Take the StreetEasy app with you.
      </PrimaryLarge>
      <S.MobileAppIcons>
        {(platform === "iOS" || platform === "desktop") && (
          <S.Link href="https://apps.apple.com/app/id660363289?mt=8">
            Download on the App Store
            <S.Img alt="" loading="lazy" src={appStoreIcon} />
          </S.Link>
        )}
        {(platform === "android" || platform === "desktop") && (
          <S.Link href="https://play.google.com/store/apps/details?id=com.zillow.android.streeteasy&referrer=adjust_reftag%3DcQEqOIBKlKmgN%26utm_source%3DOwned%26utm_campaign%3Ds_Desktop%26utm_content%3DHomepage%26utm_term%3DFooter">
            Get it on Google Play
            <S.Img alt="" loading="lazy" src={googlePlayIcon} />
          </S.Link>
        )}
      </S.MobileAppIcons>
    </S.MobileAppsContainer>
  );
};

export default MobileApps;
